import { Link } from "react-router-dom";
import { LINKS, ASSETS, SOURCES } from "@/data/content";
import { Dot } from "@/components/System";

const SYSTEM_LINKS = [
    { label: "SYSTEM", path: "/" },
    { label: "RUNTIME", path: "/runtime" },
    { label: "PROOF", path: "/proof" },
    { label: "ARCHITECTURE", path: "/architecture" },
    { label: "AGENTS", path: "/agents" },
    { label: "ECONOMY", path: "/economy" },
    { label: "TERMINAL", path: "/terminal" },
    { label: "DOCS", path: "/docs" },
    { label: "SOURCES", path: "/sources" },
];

export const Footer = () => (
    <footer className="border-t border-[rgba(0,217,255,0.12)] bg-[#05070B]" data-testid="footer">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
            <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
                <div>
                    <div className="flex items-center gap-3">
                        <img src={ASSETS.logo} alt="AgentVM logo" className="h-9 w-9 border border-[rgba(0,217,255,0.3)] object-cover" />
                        <span className="font-mono text-sm tracking-[0.2em] text-[#F5F9FF]">AGENTVM://SYSTEM</span>
                    </div>
                    <p className="mt-4 font-mono text-xs leading-relaxed tracking-[0.1em] text-[#B8C7D9]/80">
                        PRIVATE INTELLIGENCE.
                        <br />
                        PROVABLE ACTION.
                    </p>
                    <div className="vm-micro-dim mt-6 flex items-center gap-2">
                        <Dot /> SYSTEM STATUS: ONLINE
                    </div>
                </div>

                <div>
                    <div className="vm-micro mb-4">SYSTEM</div>
                    <ul className="space-y-2">
                        {SYSTEM_LINKS.map((l) => (
                            <li key={l.path}>
                                <Link
                                    to={l.path}
                                    data-testid={`footer-${l.label.toLowerCase()}`}
                                    className="font-mono text-[11px] tracking-[0.18em] text-[#B8C7D9]/70 transition-colors hover:text-[#00D9FF]"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="vm-micro mb-4">OFFICIAL SOURCES</div>
                    <ul className="space-y-2">
                        {[
                            { label: "AGENTVM", url: LINKS.agentvm },
                            { label: "ARC", url: LINKS.arc },
                            { label: "CIRCLE AGENT STACK", url: LINKS.circleAgents },
                            { label: "ARC DOCS", url: LINKS.arcDocs },
                        ].map((l) => (
                            <li key={l.label}>
                                <a
                                    href={l.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`footer-src-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="font-mono text-[11px] tracking-[0.18em] text-[#B8C7D9]/70 transition-colors hover:text-[#00D9FF]"
                                >
                                    {l.label} ↗
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="vm-micro mb-4">ACTIONS</div>
                    <div className="flex flex-col items-start gap-2">
                        <a href={LINKS.buy} target="_blank" rel="noopener noreferrer" data-testid="footer-buy" className="border border-[#1688FF]/60 bg-[#006CFF]/20 px-3 py-1.5 font-mono text-[10px] tracking-[0.22em] text-[#F5F9FF] transition-colors hover:bg-[#006CFF]/40">
                            BUY $AGENTVM ↗
                        </a>
                        <span data-testid="footer-chart" title="PAIR DATA NOT AVAILABLE" className="cursor-not-allowed border border-[rgba(0,217,255,0.25)] px-3 py-1.5 font-mono text-[10px] tracking-[0.22em] text-[#B8C7D9]/40">
                            CHART — DATA NOT AVAILABLE
                        </span>
                        <a href={LINKS.x} target="_blank" rel="noopener noreferrer" data-testid="footer-x" className="border border-[rgba(0,217,255,0.25)] px-3 py-1.5 font-mono text-[10px] tracking-[0.22em] text-[#B8C7D9] transition-colors hover:border-[#00D9FF]/60 hover:text-[#00D9FF]">
                            X ↗
                        </a>
                    </div>
                </div>
            </div>

            <div className="mt-12 flex flex-col gap-3 border-t border-[rgba(0,217,255,0.08)] pt-6 sm:flex-row sm:items-center sm:justify-between">
                <span className="vm-micro-dim">AGENTVM — THE VERIFIABLE RUNTIME FOR AI AGENTS</span>
                <span className="vm-micro-dim">{SOURCES.length} OFFICIAL SOURCES REGISTERED · DEMO DATA LABELED ON SITE</span>
            </div>
        </div>
    </footer>
);
